import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { DrawerRef,  DRAWER_DATA_VAR } from 'mis-crystal-design-system/drawer';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { parseZone } from 'moment';
import { PaymentService } from 'src/app/shared/services/paymentService.service';
import { takeUntil } from 'rxjs/operators';
import { UtilService } from '../../../../shared/services/util.service';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';
import { MyBookingsService } from '../../my-bookings.service';
import { PaymentButtonService } from 'src/app/shared/services/payment-button.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { Subscription, Observable, timer } from 'rxjs';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';


declare var Razorpay: any;
@Component({
  selector: 'app-booking-details-sidebar',
  templateUrl: './booking-details-sidebar.component.html',
  styleUrls: ['./booking-details-sidebar.component.scss']
})
export class BookingDetailsSidebarComponent implements OnInit {

  @Output() paymentFailedCallback = new EventEmitter();
  public booking: any;
  public bookingSource: any;
  public bookingDestination: any;
  public noOfStops: any;
  public label = "More";
  public startTime: any; openD;
  public miscelleneousConfig: any;
  public tab: any;
  public ridersList: any;
  dropdownData: DropdownItem[] = [
    { label: 'Edit', value: "1" },
    { label: 'Duplicate', value: "2" },
    // { label: 'View Document', value: "3" },
    { label: 'View History', value: "4" },
    // { label: 'Upload Document', value: "5" },
    { label: 'Cancel', value: "6" },
  ];
  selectedItem: DropdownItem;
  destroy$ = new Subject();
  public orderId: any = "";
  public options = {
    key: environment.razorPayApiKey,
    order_id: this.orderId,
    amount: null,
    image: 'assets/MoveinSync-Rentlz.png',
    prefill: {
      contact: null,
      email: null
    },
    theme: {
      color: 'rgb(19, 54, 130)'
    },
    handler: this.handleRazorPayPayment.bind(this)
  };
  public rzp1: any;
  requestObj: any;
  showToast = false;
  toastMessage = '';
  isLoading = false;
  noCardDetails = true;
  carDetails;
  selectedValue;
  request;
  public paymentAmount: any;
  enablePayment: boolean;
  showOtpProperty: boolean;
  private subscription: Subscription;
  private timer: Observable<any>;
  documentList: any = [];
  sideMenu = false;
  passanger: any[] = [];
  marshall: any;
  multidayTrips: any[] = [];
  stopsDetails: any;

  travelPurposeConfig: any;
  reasonConfig: any;
  flightDetailsConfig: any;
  otherDetailsConfig: any;
  bookingFinalStatus: any;

  constructor(private drawerRef: DrawerRef,
              @Inject(DRAWER_DATA_VAR) private data: any,
              private utilService: UtilService,
              private authService: AuthService,
              private paymentService: PaymentService,
              private myBookingService: MyBookingsService,
              private cdr: ChangeDetectorRef,
              private datePipe: DatePipe,
              private paymentButtonService: PaymentButtonService,
              private commonService: CommonService, private commonBookingSrv: CommonBookingService) {
    this.booking = data.data;
    this.miscelleneousConfig = data.miscelleneousConfig;
    this.tab = data.tab;
    if (this.tab == 'past' || this.booking.bookingStatus == 'CANCELLED') {
      this.dropdownData = [
        { label: 'Edit', value: "1" },
        { label: 'Duplicate', value: "2" },
        // { label: 'View Document', value: "3" },
        { label: 'View History', value: "4" },
        // { label: 'Upload Document', value: "5" },

      ];
    } else {
      this.dropdownData = [
        { label: 'Edit', value: "1" },
        { label: 'Duplicate', value: "2" },
        // { label: 'View Document', value: "3" },
        { label: 'View History', value: "4" },
        // { label: 'Upload Document', value: "5" },
        { label: 'Cancel', value: "6" },
      ];
    }

  }

  ngOnInit(): void {
    [this.travelPurposeConfig, 
      this.reasonConfig ,
      this.flightDetailsConfig, 
      this.otherDetailsConfig] = this.commonService.getTripDetailsEleConfig(['travelPurpose', 'reason', 'flightDetails', 'otherDetails'])
    if (this.booking.multiDayBooking){
      this.multidayTrips.push(
        {
          day: 1,
          stops: this.booking.stops.map(item => ({
              address: item.address,
              geoArea: item.geoArea
          }))
        }
      );
      this.booking.multiDays.forEach(day => {
        this.multidayTrips.push({
         day: day.day,
         stops: day.stops.map(item => ({
              address: item.address,
              geoArea: item.geoArea
         }))
        });
      });
    }
    this.bookingFinalStatus = this.commonBookingSrv.getCabAllocationStatus(this.booking);
    this.stopsDetails = this.myBookingService.getStopsCompleteView(this.booking, this.miscelleneousConfig['12hrTimeFormat']);

    this.noOfStops = this.booking.stops?.length;
    const ridersList = [];
    for (const stop of this.booking.stops) {
      if (Number(stop.priorityOrder) === 1) {
        this.bookingSource = stop;
      }
      if (Number(stop.priorityOrder) === this.noOfStops && this.noOfStops !== 1) {
        this.bookingDestination = stop;
      }
      for (const rider of stop.riders) {
        if (!ridersList.length) {
          ridersList.push(rider);
        } else {
          let riderExists = false;
          for (const newRider of ridersList) {
            if (newRider.personId === rider.personId) {
              riderExists = true;
              break;
            }
          }
          if (!riderExists) {
            ridersList.push(rider);
          }
        }
      }
    }
    this.ridersList = ridersList;

    this.startTime = this.getBookingTime(this.booking);

    this.request = {
      userEmail: this.authService?.user?.info?.employee?.emailId,
      buid: this.authService.user.buId,
    };
    this.options.amount = this.booking.bookingAmount;
    this.options['name'] = 'Trip Amount';
    this.options.prefill.contact = this.authService.user.info ? this.authService.user.info.employee.phone : '';
    this.options.prefill.email = this.authService.user.info ? this.authService.user.info.employee.emailId : '';

    this.paymentAmount = this.booking.paymentAmount ;

    this.requestObj = {
      buid : this.authService.user.buId,
      amount: this.booking.bookingAmount ,
      appName: "SPOT",
      details: {
        booking_id:  this.booking.bookingId,
      },
      paymentType: "razorpay",
      userEmail: this.authService.user.info.employee.emailId,
      userName: this.authService.user.info.employee.employeeName
    };
    this.myBookingService.paymentAmount.next(this.paymentAmount);
    this.commonService.fetchWorkflowConfig().subscribe((res: any) =>
     {
      this.commonService.workflowConfig = res;
      this.showOtpProperty = res.showOTPOnDashboard;
      this.enablePayment = res.enablePaymentGateway;
    }
    );

    this.myBookingService.fetchDocuments(this.booking.bookingId).subscribe(res => {
      this.documentList = Object.entries(res).slice(1).map(([filename, filesize]) => ({ filename, filesize }));
    });


    this.booking?.stops.forEach(stop => {
      stop?.riders.forEach(rider => {
        if (rider.riderType !== 'MARSHAL' && this.passanger.indexOf(rider) < 0 && rider.boardingType == "PickUp") {
          this.passanger.push(rider);
        }
        else if (rider.riderType === 'MARSHAL') {
        this.marshall = rider;
 }
      });
    });

  }


  getBookingTime(booking: any) {
    if (booking.startTime) {
      const dateMoment = this.utilService.getMoment(booking.startTime);
      return this.miscelleneousConfig['12hrTimeFormat'] === 'true' ?
      dateMoment.format('hh:mm A') : dateMoment.format('HH:mm');
    }
    return '--:--';
  }


  changeOption(event) {
    this.selectedItem = event;
    switch (event.value) {
      case '1':
        this.data.method('edit');
        break;
      case '2':
        this.data.method('duplicate');
        break;
      case '3':
        this.data.method('document');
        break;
      case '4':
        this.data.method('history');
        break;
        case '5':
        this.data.method('upload');
        break;
      case '6':
        this.data.method('cancel');
        break;
      default:
    }
  }

  cancelBooking(){
  this.data.method('cancel');
  }

  payBookingAmt(){
     this.myBookingService.openSnackBar.next(true);
     this.timer = timer(3000);
     this.subscription = this.timer.subscribe(() =>   this.myBookingService.openSnackBar.next(false));
     setTimeout(() => {
      this.paymentButtonService.createOrder(this.requestObj).subscribe((res) => {
        if (res && res["id"]){
          this.options["order_id"] = res["id"];
          this.options["customer_id"] = res["customerId"];
          this.rzp1 = new Razorpay(this.options);
          this.rzp1.open();
        }
      },
      (error) => {
        if (this.paymentFailedCallback) {
          this.paymentFailedCallback.emit(error.error.message);
        }
      });
    }, 3000);
  }
  handleRazorPayPayment(response) {
    this.myBookingService.razorpay_payment_id.next(response.razorpay_payment_id);
    this.myBookingService.verifyPayment(response).subscribe((res) => {
      if (res) {
        this.myBookingService.singlePaymentPopup.next(true);
        this.myBookingService.paymentStatus.next(res);
        this.drawerRef.close();
      } });
    this.fetchCardDetails();
  }

  fetchCardDetails() {
    this.isLoading = true;
    this.paymentService.fetchCardDetails(this.request).
      pipe(takeUntil(this.destroy$)).
      subscribe((data) => {
        this.isLoading = false;
        if (data.status === 204) {
          this.noCardDetails = true;
        }

        if (data.status == 200) {
          this.noCardDetails = false;
          this.carDetails = data['body'];
          this.selectedValue = this.carDetails[0]['defaultCard'];
          this.cdr.detectChanges();
        }
      }, (error) => {
        this.showToast = true;
        this.toastMessage = "Cannot process the request.";

      });
  }

  checkBtnVisibility() {
    if (this.enablePayment){
      if (this.booking.paymentType == 'Bill To User' && (this.booking.paymentStatus == 'PENDING' || this.booking.paymentStatus == 'FAILED')) {
      return true;
      }
    }
    return false;
  }


  OpenTrack() {
    this.data.method('track');
  }

  edit() {
    this.data.method('edit');
  }

  uploadDocument(){
    this.data.method('upload');
  }
  close() {
    this.drawerRef.close();
  }

  transformDate(date: string) {
    const dateString = parseZone(date, 'DD/MM/YYYY').format();
    return this.datePipe.transform(dateString, 'EEE, MMM dd');
  }

  getPaymentStatus(status){
    switch (status) {
      case ('NOT_REQUIRED_FOR_NOW' || 'NOT_APPLICABLE' || 'UNDEFINED' || 'BACKENED_HOLD' ):
        return "N/A";
      case 'PROCESSING':
        return "PROCESSING";
      case 'PENDING':
        return "PENDING";
      case 'PAID':
        return "PAID";
      case 'FAILED':
        return "FAILED";
      default:
    }
  }
  duplicatBooking()
  {
    this.data.method('duplicate');
  }
  viewHistory()
  {
   this.data.method('history');
  }

}
